import Modal from "../Framework/Components/Modals/Modal";
import {ModalType} from "../Framework/Types/ModalTypes";
import {useSite} from "../Providers/SiteProvider";
import {Document, Page, pdfjs} from 'react-pdf';
import {useEffect, useReducer, useState} from "react";
import StackHorizontal from "../Framework/Components/Wrappers/StackHorizontal";
import Button from "../Framework/Components/Buttons/Button";
import {FlexAlign, FlexGap, FlexJustify} from "../Framework/Data/Enums/LayoutEnums";

pdfjs.GlobalWorkerOptions.workerSrc = '../../pdf.worker.min.js';

const PDFViewerModal = (props: ModalType) => {
    const { pDFViewerDetails } = useSite();

    const [ pdf, setPdf] = useState<any>({url : pDFViewerDetails.uri});

    const [zoomLevel, setZoomLevel] = useReducer((state: number, action: string) => {
        switch (action) {
            case 'increase':
                let increaseValue = state + 1;
                return increaseValue > 5 ? 5 : increaseValue;
            case 'decrease':
                let decreaseValue = state - 1;
                return decreaseValue < 1 ? 1 : decreaseValue;
            default:
                return state;
        }
    }, 0);

    const [totalPages, setTotalPages] = useState<number>(1);
    const [pageNumber, setPageNumber] = useState<number>(1);

    const onDocumentLoadSuccess = (props : any) => {
        setTotalPages(props.numPages);
    }

    useEffect(() => {
        return () => {
            setPageNumber(1);
            setTotalPages(1);
        }
    }, []);

    useEffect(() => {
        setPageNumber(1);
        setTotalPages(1);
        setPdf({url : pDFViewerDetails.uri});
    }, [pDFViewerDetails]);

    return (
        <Modal title={'PDF Viewer'} isOpen={props.visible} closeCallback={props.closeCallback}>
            <object data={pdf.url} type="application/pdf" />

            {/*
            <Document
                file={pdf.url}
                onLoadSuccess={onDocumentLoadSuccess}
            >
                <Page
                    pageNumber={pageNumber}
                    scale={zoomLevel}
                />
            </Document>

            <StackHorizontal justify={FlexJustify.Between} align={FlexAlign.Center} gap={FlexGap.Small}>
                <StackHorizontal justify={FlexJustify.Between} align={FlexAlign.Center}>
                    <Button title={'Zoom Out'} onClick={() => setZoomLevel('decrease')} disabled={zoomLevel === 1}/>
                    <div>
                        <strong>{zoomLevel}</strong>
                    </div>
                    <Button title={'Zoom In'} onClick={() => setZoomLevel('increase')} disabled={zoomLevel === 5}/>
                </StackHorizontal>

                <StackHorizontal justify={FlexJustify.Between} align={FlexAlign.Center}>
                    <Button title={'Previous'} onClick={() => setPageNumber(pageNumber - 1)} disabled={pageNumber === 1 || totalPages === 1}/>
                    <div>
                        <strong>{pageNumber}</strong>/{totalPages}
                    </div>
                    <Button title={'Next'} onClick={() => setPageNumber(pageNumber + 1)} disabled={pageNumber === totalPages}/>
                </StackHorizontal>
            </StackHorizontal>*/}
        </Modal>
    )
}

export default PDFViewerModal